module.exports = __webpack_public_path__ + "img/finance_thumbnail.c4af49df.jpg";